import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CSSTransitionGroup } from 'react-transition-group';
import classnames from 'classnames';
import { map } from 'lodash/fp';
import clickOutside from 'react-click-outside';

import { ReactComponent as Arrow } from '../../../../../../svgs/leftarrow.svg';
import HoverButton from '../HoverButton/index';
import styles from './serviceFilter.module.css';
import { filterServices, contains } from '../../filterFunctions';

class ServiceFilter extends Component {
  static propTypes = {
    filterDoctors: PropTypes.func.isRequired,
    services: PropTypes.arrayOf(PropTypes.object).isRequired,
    selectedService: PropTypes.object,
  };
  constructor(props) {
    super(props);
    this.toggleOptions = this.toggleOptions.bind(this);
    this.show = this.show.bind(this);
    this.handleOptionClick = this.handleOptionClick.bind(this);
    this.onChange = this.onChange.bind(this);
    this.sortServices = this.sortServices.bind(this);
  }
  state = {
    selectedService: this.props.selectedService ?? {
      Id: 0,
      Name: 'All Services',
    },
    serviceFilterString: '',
    services: this.props.services,
    showOptions: false,
  };
  componentDidMount() {
    this.sortServices(this.props.services);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.services !== this.props.services) {
      this.setState({ services: this.props.services });
    }
    if (prevProps.selectedService !== this.props.selectedService) {
      this.setState({
        selectedService: this.props.selectedService ?? {
          Id: 0,
          Name: 'All Services',
        },
      });
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextProps.services !== this.props.services ||
      nextProps.selectedService !== this.props.selectedService ||
      nextState !== this.state
    );
  }
  onChange() {
    let serviceFilterString = this.input.value;
    let filteredServices = filterServices(
      serviceFilterString,
      this.props.services,
    );
    if (this.input.value.length <= 0) {
      filteredServices = this.props.services;
    }
    this.sortServices(filteredServices);
    this.setState({ serviceFilterString });
  }
  // UNSAFE_componentWillReceiveProps(nextProps) {
  //   if (nextProps.currentServiceFilter !== this.props.currentServiceFilter) {
  //     this.setState({ currentServiceFilter: nextProps.currentServiceFilter });
  //   }
  // }
  // shouldComponentUpdate = (nextProps, nextState) => nextState !== this.state;
  show() {
    if (!this.state.showOptions) this.setState({ showOptions: true });
  }
  toggleOptions() {
    this.setState({ showOptions: !this.state.showOptions });
  }
  handleOptionClick(option) {
    if (option) {
      this.toggleOptions();
      this.setState({ selectedService: option });
      this.props.filterDoctors(option.Id);
    }
  }
  handleClickOutside = () => {
    this.setState({ showOptions: false });
  };

  sortServices(services) {
    services = services.toSorted(function(a, b) {
      if (a.Name < b.Name) {
        return -1;
      }
      if (a.Name > b.Name) {
        return 1;
      }
      return 0;
    });
    services = services.toSpliced(0, 0, { Id: 0, Name: 'All Services' });
    this.setState({ services });
  }

  render() {
    return (
      <CSSTransitionGroup
        component="div"
        className={classnames(styles.container, {
          [styles.shown]: this.state.showOptions,
        })}
        transitionName={{
          enter: styles.enter,
          enterActive: styles.enterActive,
          leave: styles.leave,
          leaveActive: styles.leaveActive,
        }}
        transitionEnterTimeout={500}
        transitionLeaveTimeout={500}
      >
        <div onClick={this.show} className={styles.currentContainer}>
          {this.state.showOptions ? (
            <input
              ref={c => {
                this.input = c;
              }}
              className={styles.input}
              type="text"
              placeholder="Search Services"
              text={this.state.serviceFilterString}
              onChange={this.onChange}
              // onKeyPress={this.addFilter}
            />
          ) : (
            <div onClick={this.show}>
              {this.state.selectedService?.Name.toLowerCase()}
            </div>
          )}
          <Arrow className={styles.arrow} onClick={this.toggleOptions} />
        </div>
        {this.state.showOptions ? (
          <div className={styles.options}>
            {map(
              option => (
                <HoverButton
                  key={option.Id}
                  onClick={() => this.handleOptionClick(option)}
                  label={option.Name}
                  styles={styles.option}
                  hoveredStyles={styles.optionHovered}
                />
              ),
              this.state.services,
            )}
          </div>
        ) : null}
      </CSSTransitionGroup>
    );
  }
}

export default clickOutside(ServiceFilter);
// for testing
export { ServiceFilter };
